/**
 * エラー文言変換に必要な最小フィールド。詳細（CommercialBookStatus）・
 * 登記検索（StoredCommercialPicture）双方から使えるよう構造的型で受ける。
 */
export interface CommercialBookErrorSource {
  status?: string | null;
  errorDetail: string | null;
  matchMethod: string;
  conditionLocation: string | null;
  conditionCompanyName: string | null;
  corporateNumber: string | null;
}

/**
 * バックエンドから受け取ったレスポンスからメッセージに変換する
 * エラーでは無い、または存在しないエラーの場合は空文字を返す
 * @param commercialBookStatus バックエンドから受け取ったレスポンス（の最小フィールド）
 */
export const getCommercialBookErrorMessage = (
  commercialBookStatus: CommercialBookErrorSource
): string => {
  const messageTable: Record<string, string> = {
    NO_RECORDS_ERROR:
      "検索した商業登記はありません。入力事項を確認の上、再度請求してください。",
    EXISTING_SESSION_ERROR:
      "サイトが混雑しているため取得できませんでした。再度請求してください。",
    REGISTRATION_IN_PROGRESS_ERROR:
      "請求のあった会社・法人等は登記事件の処理中です。登記が完了した後に再度請求してください。",
    INVALID_INPUT_ERROR:
      "入力事項に誤りがあります。会社法人等番号などを確認の上、再度請求してください。",
    PROVIDER_ERROR:
      "登記情報提供サービスでエラーが発生しました。時間をおいて再度請求してください。",
    PDF_DOWNLOAD_EXPIRED:
      "登記情報提供サービスのPDF取得期限を過ぎたため取得できませんでした。必要な場合は再度請求してください。",
    PURCHASE_NOT_FOUND:
      "登記情報提供サービスへの請求が確認できませんでした。再度請求してください。",
  };
  if (commercialBookStatus.errorDetail) {
    const errorDetail = commercialBookStatus.errorDetail;
    if (errorDetail === "NO_RECORDS_ERROR") {
      // エラーがNO_RECORDS_ERRORの場合の特別処理
      if (commercialBookStatus.matchMethod === "商号・名称") {
        if (
          commercialBookStatus.conditionLocation &&
          commercialBookStatus.conditionCompanyName
        ) {
          const location = commercialBookStatus.conditionLocation;
          const companyName = commercialBookStatus.conditionCompanyName;

          return `${location}に${companyName}は見つかりませんでした。入力事項を確認の上、再度請求してください。`;
        }
      } else if (commercialBookStatus.matchMethod === "会社法人等番号") {
        if (
          commercialBookStatus.conditionLocation &&
          commercialBookStatus.corporateNumber
        ) {
          const location = commercialBookStatus.conditionLocation;
          const corporateNumber = commercialBookStatus.corporateNumber;

          return `${location}に${corporateNumber}は見つかりませんでした。入力事項を確認の上、再度請求してください。`;
        }
      }
    }

    if (commercialBookStatus.status === "NEEDS_REVIEW")
      return "取得結果を確認中です。二重取得を避けるため、同じ法人の再依頼を控えてお待ちください。";
    return (
      messageTable[errorDetail] ??
      "取得に失敗しました。解決しない場合はサポートへお問い合わせください。"
    );
  }
  return "";
};
